export class ColorModel {
    constructor(public entityId: number, public entityName: string, public entityColor: string, public entityType: EntityType) { }
}

export enum EntityType {
    Publisher = 0,
    PublisherGroup = 1,
    Provider = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/color.model.ts